<template>
  <div class="base-param-collection">
    
    <div class="search-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="中文名称">
          <el-input v-model="searchForm.name" placeholder="请输入中文名称"></el-input>
        </el-form-item>
        <el-form-item label="编码1">
          <el-input v-model="searchForm.code1" placeholder="请输入编码1"></el-input>
        </el-form-item>
        <el-form-item label="编码2">
          <el-input v-model="searchForm.code2" placeholder="请输入编码2"></el-input>
        </el-form-item>
        <el-form-item label="编码3">
          <el-input v-model="searchForm.code3" placeholder="请输入编码3"></el-input>
        </el-form-item>
        <el-form-item label="是否过期">
          <el-select v-model="searchForm.expired" placeholder="全部">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="status-filter-bar">
      <span class="status-filter-label">状态：</span>
      <div class="status-filter-group">
        <el-radio-group v-model="statusFilter" size="medium">
          <el-radio label="all">全部</el-radio>
          <el-badge :value="statusCounts[2]" :hidden="statusCounts[2] === 0" type="danger" class="status-badge">
            <el-radio label="2">待同步</el-radio>
          </el-badge>
          <el-radio label="3">已同步</el-radio>
          <el-radio label="4">无差异</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="type-tabs">
      <el-tabs v-model="searchForm.type">
        <el-tab-pane label="海关关区" name="customs_area"></el-tab-pane>
        <el-tab-pane label="运输方式" name="transport_mode"></el-tab-pane>
        <el-tab-pane label="监管方式" name="supervision_mode"></el-tab-pane>
        <el-tab-pane label="征免性质" name="tax_nature"></el-tab-pane>
        <el-tab-pane label="国别" name="country"></el-tab-pane>
        <el-tab-pane label="国内地区" name="domestic_area"></el-tab-pane>
        <el-tab-pane label="监管类别名称" name="supervision_category"></el-tab-pane>
        <el-tab-pane label="指运港" name="destination_port"></el-tab-pane>
        <el-tab-pane label="成交方式" name="trade_mode"></el-tab-pane>
        <el-tab-pane label="包装种类" name="packaging_type"></el-tab-pane>
        <el-tab-pane label="报关单类型" name="declaration_type"></el-tab-pane>
        <el-tab-pane label="离境口岸" name="exit_port"></el-tab-pane>
        <el-tab-pane label="随附单证代码" name="document_code"></el-tab-pane>
        <el-tab-pane label="随附单据文件类别" name="document_category"></el-tab-pane>
        <el-tab-pane label="计量单位" name="unit"></el-tab-pane>
        <el-tab-pane label="币种" name="currency"></el-tab-pane>
        <el-tab-pane label="征免方式" name="tax_mode"></el-tab-pane>
        <el-tab-pane label="用途" name="purpose"></el-tab-pane>
        <el-tab-pane label="危险品包装类别" name="dangerous_packaging"></el-tab-pane>
        <el-tab-pane label="集装箱规格" name="container_spec"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="button-toolbar">
      <div class="toolbar-left">
        <el-button size="medium" @click="handleFullCollection">全量采集</el-button>
        <el-button size="medium" @click="handleBatchSync">批量同步</el-button>
      </div>
      <div class="toolbar-right">
        <span>采集时间：2026-05-06 10:47:27</span>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" :disabled="scope.row.status !== 2" @click="handleSync(scope.row)">同步</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="code1" label="编码1" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.code1 || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="中文名称" width="200">
        <template slot-scope="scope">
          {{ scope.row.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.status)">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="expired" label="是否过期" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.expired ? 'status-expired' : 'status-not-expired'">
            {{ scope.row.expired ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="code2" label="编码2" width="100">
        <template slot-scope="scope">
          {{ scope.row.code2 || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="code3" label="编码3" width="100">
        <template slot-scope="scope">
          {{ scope.row.code3 || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="fullName" label="中文全称">
        <template slot-scope="scope">
          {{ scope.row.fullName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="enName" label="英文名称">
        <template slot-scope="scope">
          {{ scope.row.enName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="syncTime" label="同步时间" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 2 || scope.row.status === 4">-</span>
          <span v-else>{{ scope.row.syncTime || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 同步弹窗 -->
    <el-dialog
      title="同步基础参数信息"
      :visible.sync="syncDialogVisible"
      width="50%">
      <div class="sync-dialog-content">
        <div style="display: flex;">
          <h4>编码1：</h4><span>{{ currentSyncRow ? currentSyncRow.code1 : '' }}</span>
          <h4 style="margin-left: 50px;">中文名称：</h4><span>{{ currentSyncRow ? currentSyncRow.name : '' }}</span>
        </div>
        <el-table :data="syncDiffData" style="width: 100%">
          <el-table-column prop="field" label="字段" width="120"></el-table-column>
          <el-table-column prop="oldValue" label="原值"></el-table-column>
          <el-table-column prop="newValue" label="新值"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSync">取消</el-button>
        <el-button type="primary" @click="confirmSync">同步</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BaseParamCollection',
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 150,
      completedCount: 120,
      selectedRows: [],
      statusFilter: "all",
      syncDialogVisible: false,
      currentSyncRow: null,
      syncDiffData: [
        { field: '中文名称', oldValue: '手机', newValue: '智能手机' },
        { field: '中文全称', oldValue: '智能移动电话', newValue: '智能移动电话（5G）' },
        { field: '英文名称', oldValue: 'Mobile', newValue: 'Smartphone' }
      ],
      statusMap: {
        0: '待采集',
        1: '采集失败',
        2: '待同步',
        3: '已同步',
        4: '无差异',
        5: '采集中'
      },
      typeMap: {
        customs_area: '海关关区',
        transport_mode: '运输方式',
        supervision_mode: '监管方式',
        tax_nature: '征免性质',
        country: '国别',
        domestic_area: '国内地区',
        supervision_category: '监管类别名称',
        destination_port: '指运港',
        trade_mode: '成交方式',
        packaging_type: '包装种类',
        declaration_type: '报关单类型',
        exit_port: '离境口岸',
        document_code: '随附单证代码',
        document_category: '随附单据文件类别',
        unit: '计量单位',
        currency: '币种',
        tax_mode: '征免方式',
        purpose: '用途',
        dangerous_packaging: '危险品包装类别',
        container_spec: '集装箱规格'
      },
      searchForm: {
        type: 'customs_area',
        name: '',
        code1: '',
        code2: '',
        code3: '',
        expired: ''
      },
      statusCounts: {
        all: 0,
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      }
    }
  },
  mounted() {
    this.generateTableData()
  },
  methods: {
    generateTableData() {
      this.tableData = [
        {
          id: '1',
          type: 'customs_area',
          name: '北京海关',
          fullName: '中华人民共和国北京海关',
          enName: 'Beijing Customs',
          code1: '1100',
          code2: 'BJC',
          code3: '',
          status: 2,
          statusText: this.statusMap[2],
          expired: false,
          collectTime: '2026-05-06 10:00:00',
          syncTime: ''
        },
        {
          id: '2',
          type: 'customs_area',
          name: '上海海关',
          fullName: '中华人民共和国上海海关',
          enName: 'Shanghai Customs',
          code1: '2200',
          code2: 'SHC',
          code3: '',
          status: 3,
          statusText: this.statusMap[3],
          expired: false,
          collectTime: '2026-05-05 09:37:41',
          syncTime: '2026-05-05 14:00:00'
        },
        {
          id: '3',
          type: 'transport_mode',
          name: '海运',
          fullName: '海洋运输',
          enName: 'Sea Transport',
          code1: '2',
          code2: '',
          code3: '',
          status: 2,
          statusText: this.statusMap[2],
          expired: false,
          collectTime: '2026-05-04 10:00:00',
          syncTime: ''
        },
        {
          id: '4',
          type: 'transport_mode',
          name: '空运',
          fullName: '航空运输',
          enName: 'Air Transport',
          code1: '5',
          code2: '',
          code3: '',
          status: 3,
          statusText: this.statusMap[3],
          expired: false,
          collectTime: '2026-05-03 11:00:00',
          syncTime: '2026-05-03 14:00:00'
        },
        {
          id: '5',
          type: 'supervision_mode',
          name: '一般贸易',
          fullName: '一般贸易',
          enName: 'General Trade',
          code1: '0110',
          code2: '',
          code3: '',
          status: 4,
          statusText: this.statusMap[4],
          expired: false,
          collectTime: '2026-05-02 12:00:00',
          syncTime: ''
        },
        {
          id: '6',
          type: 'supervision_mode',
          name: '加工贸易',
          fullName: '加工贸易',
          enName: 'Processing Trade',
          code1: '0615',
          code2: '',
          code3: '',
          status: 3,
          statusText: this.statusMap[3],
          expired: false,
          collectTime: '2026-05-01 08:00:00',
          syncTime: '2026-05-01 10:00:00'
        },
        {
          id: '7',
          type: 'tax_nature',
          name: '一般征税',
          fullName: '一般征税',
          enName: 'General Taxation',
          code1: '101',
          code2: '',
          code3: '',
          status: 2,
          statusText: this.statusMap[2],
          expired: false,
          collectTime: '2026-04-30 09:00:00',
          syncTime: ''
        },
        {
          id: '8',
          type: 'tax_nature',
          name: '来料加工',
          fullName: '来料加工装配',
          enName: 'Processing with Materials',
          code1: '502',
          code2: '',
          code3: '',
          status: 4,
          statusText: this.statusMap[4],
          expired: false,
          collectTime: '2026-04-29 10:00:00',
          syncTime: ''
        },
        {
          id: '9',
          type: 'country',
          name: '美国',
          fullName: '美利坚合众国',
          enName: 'United States',
          code1: '502',
          code2: 'USA',
          code3: '',
          status: 3,
          statusText: this.statusMap[3],
          expired: false,
          collectTime: '2026-04-28 11:00:00',
          syncTime: '2026-04-28 14:00:00'
        },
        {
          id: '10',
          type: 'unit',
          name: '台',
          fullName: '台',
          enName: 'Unit',
          code1: '012',
          code2: '',
          code3: '',
          status: 2,
          statusText: this.statusMap[2],
          expired: true,
          collectTime: '2026-04-27 13:00:00',
          syncTime: ''
        }
      ]
      this.calculateStatusCounts()
    },
    calculateStatusCounts() {
      this.statusCounts = {
        all: this.tableData.length,
        0: this.tableData.filter(item => item.status === 0).length,
        1: this.tableData.filter(item => item.status === 1).length,
        2: this.tableData.filter(item => item.status === 2).length,
        3: this.tableData.filter(item => item.status === 3).length,
        4: this.tableData.filter(item => item.status === 4).length,
        5: this.tableData.filter(item => item.status === 5).length
      }
    },
    getTypeText(type) {
      return this.typeMap[type] || type
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    handleSearch() {
      this.currentPage = 1
      this.generateTableData()
    },
    handleReset() {
      this.searchForm = {
        type: 'customs_area',
        name: '',
        code1: '',
        code2: '',
        code3: '',
        expired: ''
      }
      this.currentPage = 1
      this.generateTableData()
    },
    handleFullCollection() {
      this.$confirm('全量采集会将当前参数类型已采集的数据清空，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({ type: 'success', message: '全量采集任务已开始' })
      }).catch(() => {})
    },
    handleBatchSync() {
      if (this.selectedRows.length === 0) {
        this.$message({ type: 'warning', message: '请先选择基础参数' })
        return
      }
      this.$confirm(`是否继续同步${this.selectedRows.length}条商品编码信息？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({ type: 'success', message: '批量同步任务已开始' })
      }).catch(() => {})
    },
    handleSync(row) {
      if (row.expired) {
        this.$confirm('该基础参数已过期是否确认同步？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.currentSyncRow = row
          this.syncDialogVisible = true
        }).catch(() => {})
      } else {
        this.currentSyncRow = row
        this.syncDialogVisible = true
      }
    },
    confirmSync() {
      this.syncDialogVisible = false
      this.$message({ type: 'success', message: `同步参数 ${this.currentSyncRow.name} 成功` })
    },
    cancelSync() {
      this.syncDialogVisible = false
      this.currentSyncRow = null
    },
    getTagType(status) {
      switch (status) {
        case 0: return 'warning'
        case 1: return 'danger'
        case 2: return 'info'
        case 3: return 'success'
        case 4: return 'success'
        case 5: return 'primary'
        default: return ''
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
    },
    handleCurrentChange(current) {
      this.currentPage = current
    }
  }
}
</script>

<style scoped>
.base-param-collection {
  padding: 0;
}

.search-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.search-form >>> .el-form-item {
  margin-bottom: 0;
}

.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: var(--text-secondary);
}

.type-tabs {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 0 20px;
  margin-bottom: 16px;
  border: 1px solid var(--border-color);
}

.type-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}

.type-tabs >>> .el-tabs__nav-wrap::after {
  display: none;
}

.type-tabs >>> .el-tabs__item {
  font-size: 14px;
  color: var(--text-secondary);
  height: 50px;
  line-height: 50px;
}

.type-tabs >>> .el-tabs__item.is-active {
  color: var(--primary-color);
  font-weight: 600;
}

.type-tabs >>> .el-tabs__active-bar {
  height: 3px;
}

.button-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.toolbar-left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.toolbar-right {
  font-size: 14px;
  color: var(--text-secondary);
}

.toolbar-right strong {
  color: var(--primary-color);
  font-weight: 600;
}

.status-filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border-color);
}

.status-filter-label {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  white-space: nowrap;
}

.status-filter-group {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.status-filter-group .el-radio-group {
  display: flex;
  gap: 0;
}

.status-filter-group .el-radio {
  padding: 6px 14px;
  margin: 0;
  border: 1px solid var(--border-color);
  border-radius: 0;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  color: var(--text-secondary);
}

.status-filter-group .el-radio:first-child {
  border-radius: 6px 0 0 6px;
}

.status-filter-group .el-radio:last-child {
  border-radius: 0 6px 6px 0;
}

.status-filter-group .el-radio:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
  z-index: 1;
}

.status-filter-group .el-radio.is-checked {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
  z-index: 1;
}

.status-filter-group .el-radio + .el-radio {
  margin-left: 0;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.status-expired {
  color: var(--warning-color);
  font-weight: 500;
}

.status-not-expired {
  color: var(--success-color);
  font-weight: 500;
}

.sync-dialog-content {
  margin-bottom: 20px;
}

.sync-dialog-content h4 {
  margin-bottom: 16px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.version-info {
  margin-bottom: 16px;
  display: flex;
  gap: 24px;
  font-size: 14px;
  color: var(--text-secondary);
  padding: 12px 16px;
  background-color: #fafafa;
  border-radius: 6px;
}

.version-info span {
  display: flex;
  align-items: center;
}

.version-info span::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.version-info span:first-child::before {
  background-color: var(--info-color);
}

.version-info span:last-child::before {
  background-color: var(--success-color);
}

.base-param-collection >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.base-param-collection >>> .el-table th {
  background-color: #fafafa !important;
  font-weight: 600;
  color: var(--text-primary);
  font-size: 13px;
}

.base-param-collection >>> .el-table td {
  padding: 12px 0;
  font-size: 13px;
}

.base-param-collection >>> .el-table__row:hover > td {
  background-color: var(--primary-bg) !important;
}

.base-param-collection >>> .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.base-param-collection >>> .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid var(--border-color);
  padding: 18px 24px;
}

.base-param-collection >>> .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.base-param-collection >>> .el-dialog__body {
  padding: 20px 24px;
}

.base-param-collection >>> .el-dialog__footer {
  border-top: 1px solid var(--border-color);
  padding: 14px 24px;
}
</style>

<style>
.status-filter-group .el-radio__input {
  display: none;
}

.status-filter-group .el-radio__label {
  padding: 0;
}

.status-filter-group .el-radio.is-checked .el-radio__label {
  color: #fff !important;
}

.status-filter-group .status-badge {
  display: inline-flex;
}

.status-filter-group .status-badge .el-badge__content {
  top: -2px;
  right: 20px;
  z-index: 10;
}

.status-filter-group .status-badge .el-radio {
  border-radius: 0;
}

.status-filter-group .status-badge:first-child .el-radio {
  border-radius: 6px 0 0 6px;
}

.status-filter-group .status-badge:last-child .el-radio {
  border-radius: 0 6px 6px 0;
}
</style>